const PurchaseProduct = {
	COURSE: 'course',
} as const;

export default PurchaseProduct;
